/* SAMPLE COLLECTORS */
export const GET_TEST_DESCRIPTIONS = "GET_TEST_DESCRIPTIONS";
export const GET_TEST_DESCRIPTIONS_SUCCESS =
  "GET_TEST_DESCRIPTIONS_SUCCESS";
export const GET_TEST_DESCRIPTIONS_FAIL = "GET_TEST_DESCRIPTIONS_FAIL";

